import PsuedoStationDepartureTime from './PsuedoStationDepartureTime';

export default PsuedoStationDepartureTime;
